<template>
    <div style="height:100%" class="white">
        <table class="report-table white">

            <thead class="report-header">
                <tr>
                    <th class="print-only">
                        <!-- will print at the top of every page -->
                        <!-- this is a placeholder component - it is only here to give spacing on every printed page so that the actual site header has space - see: https://medium.com/@Idan_Co/the-ultimate-print-html-template-with-header-footer-568f415f6d2a -->
                        &nbsp;
                    </th>
                </tr>
            </thead>

            <tbody>
                <tr>
                    <td>

                        <v-progress-linear color="primary" indeterminate v-if="loading"></v-progress-linear>
                        <v-container v-else>
                            <v-row>
                                <v-col class="text-center">
                                    <span class="font-weight-bold text-h4">BTG-UTAH VENOM DAILY-MONTH BATCH RECORD</span>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12">
                                    <span class="font-weight-bold">Year:</span> {{ poolData.Year }}
                                </v-col>
                                <v-col cols="12">
                                    <span class="font-weight-bold">Month:</span> {{ poolData.MonthName }}
                                </v-col>
                                <v-col cols="12">
                                    <span class="font-weight-bold">Species:</span> {{ poolData.SpeciesCode }}
                                </v-col>
                                <v-col cols="12">
                                    <span class="font-weight-bold">Identifier:</span> {{ poolData.Barcode }}
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-simple-table>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th class="text-left">
                                                        <span class="font-weight-bold">DATE-ROOM-RACK</span>
                                                    </th>
                                                    <th class="text-left">
                                                        <span class="font-weight-bold">No. Of Specs</span>
                                                    </th>
                                                    <th class="text-left">
                                                        <span class="font-weight-bold">Venom Vol.-ml</span>
                                                    </th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-for="item in poolData.DailyExtractionSessions"
                                                    :key="item.Barcode">
                                                    <td>{{ item.Barcode }}</td>
                                                    <td>{{ item.SpecimenCount }}</td>
                                                    <td>{{ item.VenomVolumeML }}mL</td>
                                                    <td></td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td>

                                                    </td>
                                                    <td>
                                                        <span class="font-weight-bold">{{totalSpecimens}}</span>
                                                    </td>
                                                    <td>
                                                        <span class="font-weight-bold">{{totalVolume}}mL</span>
                                                    </td>
                                                    <td>
                                                        <span class="font-weight-bold">Total gms Protein: {{totalWeight}}</span>
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </template>
                                    </v-simple-table>
                                </v-col>
                            </v-row>
                            <v-row v-if="errorMessage">
                                <v-col cols="12">
                                    <v-alert outlined type="info">{{errorMessage}}</v-alert>
                                </v-col>
                            </v-row>
                        </v-container>
                    </td>
                </tr>
            </tbody>

            <tfoot class="report-footer">
                <tr>
                    <td class="print-only">
                        <!-- will print at the bottom of every page -->
                        <!-- this is a placeholder component - it is only here to give spacing on every printed page so that the actual site footer has space - see: https://medium.com/@Idan_Co/the-ultimate-print-html-template-with-header-footer-568f415f6d2a -->
                        &nbsp;
                    </td>
                </tr>
            </tfoot>

            <!-- this will be fixed to the bottom of the page, and repeated on each printed page; to achieve the proper spacing, see: https://medium.com/@Idan_Co/the-ultimate-print-html-template-with-header-footer-568f415f6d2a -->
            <div class="print-footer-container print-only">
                Report generated by {{name}} at {{$moment().format($constants.DATE_FORMAT)}}
            </div>

        </table>
    </div>
</template>

<script>
import * as venomPoolingAPI from "@/services/venomPoolingAPI";
import * as auth from "@/services/auth";
import util from '@/helpers/util';

export default {
    props: {
        monthlyPoolID: {
            type: [ Number, String ],
            default: -1
        },
    },
    data() {
        return {
            loading: false,
            errorMessage: "",
            poolData: {}
        }
    },
    computed: {
        totalSpecimens: function() {
            return this.poolData.DailyExtractionSessions.map(x => x.SpecimenCount).reduce((a,b) => a + b, 0);
        },
        totalVolume: function() {
            return this.poolData.DailyExtractionSessions.map(x => x.VenomVolumeML).reduce((a,b) => a + b, 0);
        },
        totalWeight: function() {
            return Math.ceil(this.totalVolume * 220.0 / 1000.0)
        },
        name: function () {
            return util.getUserProfileNameFromUserObject(this.$store.state.authStore.user);
        }
    },
    methods: {
        async loadData() {
            this.loading = true;
            this.errorMessage = "";

            try {
                this.poolData = await venomPoolingAPI.getDailyMonthBatchRecord(this.monthlyPoolID)
            } catch (e) {
                this.errorMessage = e.message;
            }

            this.loading = false;

            this.print();
        },
        print() {
            this.$nextTick(() => window.print());
        }
    },
    created() {
        this.loadData();
    }
}
</script>

<style lang="scss">
#app {
    .sheep-management-data-table {
        td, th {
            padding-left: 4px;
            padding-right: 4px;

            .v-chip {
                margin-top: 2px;
                margin-bottom: 2px;
            }
        }
    }

    .report-table {
        width: 100%;
    }

    // this is a placeholder - if it is needed then we'll need to change the height
    .report-header th {
        height: 0px;
    }

    .report-footer td, .print-footer-container {
        height: 50px; // this reserves space for the actual footer, see: https://medium.com/@Idan_Co/the-ultimate-print-html-template-with-header-footer-568f415f6d2a
    }

    .print-footer-container {
        position: fixed;
        bottom: 0px;
        width: 100%;
        text-align: center;
        color: var(--v-lightgray-base);
    }
}

@media print {
    #app {
        // shade every second row
        .v-data-table__wrapper table tr:nth-child(2n) {
            background-color: var(--v-lightgray-lighten1)
        }
    }
}
</style>